"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SubscriptionPaymentStatus = exports.SubscriptionActivityStatus = void 0;
var SubscriptionActivityStatus;
(function (SubscriptionActivityStatus) {
    SubscriptionActivityStatus["ACTIVE"] = "active";
    SubscriptionActivityStatus["INACTIVE"] = "inactive";
})(SubscriptionActivityStatus = exports.SubscriptionActivityStatus || (exports.SubscriptionActivityStatus = {}));
var SubscriptionPaymentStatus;
(function (SubscriptionPaymentStatus) {
    SubscriptionPaymentStatus["FREE_TRIAL"] = "freeTrial";
    SubscriptionPaymentStatus["PAID"] = "paid";
    SubscriptionPaymentStatus["ON_HOLD"] = "onHold";
})(SubscriptionPaymentStatus = exports.SubscriptionPaymentStatus || (exports.SubscriptionPaymentStatus = {}));
